import { useState } from 'react';
import { supabase } from '../lib/constants';
import { useAuth } from '../lib/auth';

const ACTIVITY_TYPES = [
  { id: 'teaching_lecture',    label: 'Teaching Lecture',           icon: '🎓' },
  { id: 'case_report',         label: 'Case Report',                icon: '📋' },
  { id: 'mortality_morbidity', label: 'Mortality & Morbidity',      icon: '📊' },
  { id: 'journal_club',        label: 'Journal Club',               icon: '📖' },
  { id: 'quality_improvement', label: 'Quality Improvement Project', icon: '⚙️' },
  { id: 'research_project',    label: 'Research Project',           icon: '🔬' },
  { id: 'other',               label: 'Other (please specify)',      icon: '✏️' },
];

export default function ActivityForm({ onSaved, onCancel, isMobile }) {
  const { user, profile } = useAuth();
  const [form, setForm] = useState({
    date: new Date().toISOString().split('T')[0],
    activity_type: '',
    activity_type_other: '',
    title: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState('');

  const submit = async () => {
    if (!form.activity_type)  { setError('Please select an activity type.'); return; }
    if (!form.title.trim())   { setError('Please enter a title for the activity.'); return; }
    if (form.activity_type === 'other' && !form.activity_type_other.trim()) {
      setError('Please specify the activity type.'); return;
    }
    setLoading(true); setError('');

    const payload = {
      ...form,
      user_id: user.id,
      fellow_name: profile?.full_name,
      fellow_email: user.email,
      approval_status: 'pending',
    };

    const { error: e } = await supabase.from('activities').insert(payload);
    if (e) { setError(e.message); setLoading(false); return; }
    setLoading(false);
    onSaved();
  };

  const p = isMobile;

  return (
    <div style={{ background: '#F7F4F0', minHeight: '100vh', paddingBottom: p ? 80 : 0 }}>
      {/* Header */}
      <div style={{ background: '#fff', padding: p ? '14px 16px' : '16px 40px', borderBottom: '1px solid #E8E4E0', display: 'flex', alignItems: 'center', gap: 12, position: 'sticky', top: 0, zIndex: 10 }}>
        <button onClick={onCancel} style={{ background: 'none', border: 'none', color: '#2D6A8A', fontSize: 14, cursor: 'pointer', padding: 0 }}>← Back</button>
        <span style={{ fontFamily: "'DM Serif Display'", fontSize: p ? 16 : 22, color: '#1A1A1F' }}>Add Activity</span>
      </div>

      <div style={{ padding: p ? 16 : '32px 40px', maxWidth: p ? '100%' : 700, margin: '0 auto' }}>

        {error && <div style={{ background: '#FFF0F0', border: '1px solid #F4A8A8', color: '#8A2D2D', padding: '10px 14px', borderRadius: 8, fontSize: 13, marginBottom: 16 }}>{error}</div>}

        {/* Date */}
        <div style={fs.field}>
          <label style={fs.label}>Date</label>
          <input type="date" value={form.date}
            onChange={e => setForm(f => ({ ...f, date: e.target.value }))}
            style={{ ...fs.input, fontSize: p ? 15 : 13 }} />
        </div>

        {/* Activity type */}
        <div style={fs.field}>
          <label style={fs.label}>Activity Type *</label>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            {ACTIVITY_TYPES.map(a => {
              const selected = form.activity_type === a.id;
              return (
                <div key={a.id} onClick={() => setForm(f => ({ ...f, activity_type: a.id }))}
                  style={{ display: 'flex', alignItems: 'center', gap: 12, padding: p ? '13px 14px' : '10px 14px', borderRadius: 10, border: `1.5px solid ${selected ? '#1A3A5C' : '#E0DDD8'}`, background: selected ? '#EEF3FA' : '#fff', cursor: 'pointer', transition: 'all 0.15s' }}>
                  <div style={{ width: 22, height: 22, borderRadius: 6, flexShrink: 0, border: `2px solid ${selected ? '#1A3A5C' : '#C8C4C0'}`, background: selected ? '#1A3A5C' : '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {selected && <span style={{ color: '#fff', fontSize: 13, fontWeight: 700 }}>✓</span>}
                  </div>
                  <span style={{ fontSize: p ? 16 : 14 }}>{a.icon}</span>
                  <span style={{ fontSize: p ? 14 : 13, fontWeight: selected ? 600 : 400, color: selected ? '#1A3A5C' : '#333' }}>{a.label}</span>
                </div>
              );
            })}
          </div>
        </div>

        {/* Other specify */}
        {form.activity_type === 'other' && (
          <div style={fs.field}>
            <label style={fs.label}>Please Specify *</label>
            <input value={form.activity_type_other} placeholder="Describe the activity…"
              onChange={e => setForm(f => ({ ...f, activity_type_other: e.target.value }))}
              style={{ ...fs.input, fontSize: p ? 15 : 13 }} />
          </div>
        )}

        {/* Title */}
        <div style={fs.field}>
          <label style={fs.label}>Title / Description *</label>
          <textarea value={form.title} rows={3}
            placeholder="e.g. Lecture on opioid conversion for medical students…"
            onChange={e => setForm(f => ({ ...f, title: e.target.value }))}
            style={{ ...fs.input, resize: 'vertical', lineHeight: 1.6, fontSize: p ? 15 : 13 }} />
        </div>

        <div style={{ background: '#FFF8EE', border: '1px solid #F4DFA8', borderRadius: 8, padding: '10px 14px', marginBottom: 20, fontSize: 12, color: '#8A6B2A' }}>
          📋 This activity will be sent to the Program Director for approval.
        </div>

        <div style={{ display: 'flex', gap: 10 }}>
          <button onClick={onCancel} style={{ padding: '13px 18px', background: '#EEE', border: 'none', borderRadius: 10, fontSize: 14, cursor: 'pointer', fontFamily: "'DM Sans'" }}>Cancel</button>
          <button onClick={submit} disabled={loading}
            style={{ flex: 1, padding: '13px', background: '#1A3A5C', color: '#fff', border: 'none', borderRadius: 10, fontSize: 15, fontWeight: 600, cursor: 'pointer', opacity: loading ? 0.7 : 1, fontFamily: "'DM Sans'" }}>
            {loading ? 'Submitting…' : '✓ Submit Activity'}
          </button>
        </div>
      </div>
    </div>
  );
}

const fs = {
  field: { marginBottom: 18 },
  label: { display: 'block', fontSize: 11, fontWeight: 600, color: '#555', marginBottom: 8, letterSpacing: 0.4, textTransform: 'uppercase' },
  input: { width: '100%', padding: '12px 14px', border: '1.5px solid #E0DDD8', borderRadius: 10, color: '#1A1A1F', background: '#fff', outline: 'none', fontFamily: "'DM Sans'", boxSizing: 'border-box' },
};
